import './flightTrackingLabel.scss';

import { useLocalize } from 'localize-react';
import React from 'react';

import airplaneSvg from './airplane.svg';

const FlightTrackingLabel: React.FC = () => {
  const { translate } = useLocalize();
  return (
    <div className="label">
      <div className="icon-l">
        <img src={airplaneSvg} alt="airplane icon" />
      </div>
      <div className="caption">{translate('with_flight_tracking')}</div>
    </div>
  );
};

export default FlightTrackingLabel;
